import { toast } from "sonner";

/**
 * Fetch a public URL and trigger a browser download with a chosen filename.
 * Works cross-origin as long as the source sets access-control-allow-origin.
 * Falls back to a new-tab open if the fetch fails (older browsers / CSP issues).
 */
export async function downloadFromUrl(url, filename) {
  const pending = toast.loading("Preparing your download…");
  try {
    const res = await fetch(url, { mode: "cors" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const ext = (url.split("?")[0].split(".").pop() || "png").toLowerCase();
    const safeName = /\.[a-z0-9]{2,5}$/i.test(filename) ? filename : `${filename}.${ext}`;
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = safeName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objUrl), 1500);
    toast.success(`Downloaded ${safeName}`, { id: pending });
    return true;
  } catch (err) {
    toast.error("Could not download — opened in new tab instead", { id: pending });
    window.open(url, "_blank", "noopener");
    return false;
  }
}
